import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  // Shell around the PowerBI iframe. It only shows while the embed loads and,
  // in full screen, as the letterboxing around the report canvas — without a
  // paint both were white on a dark page. The report canvas itself is rendered
  // by PowerBI inside the iframe and cannot be themed from here.
  root: {
    height: '85vh',
    backgroundColor: theme.palette.custom.pageBackground,
  },
  rootFullScreen: {
    height: '100vh',
    backgroundColor: theme.palette.custom.pageBackground,
  },
  report: {
    height: '100%',
    borderWidth: '0px',
  },
  title: {
    flexGrow: 1,
  },
  loading: {
    color: theme.palette.primary.main,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '200px',
  },
  button: {
    width: '100%',
    borderRadius: 5,
    // `primary.mainBlue` used as a FILL. That key is a text colour and turns
    // light in dark mode, so the button needs the dedicated brand fill token.
    backgroundColor: theme.palette.custom.brandButtonBackground,
    color: theme.palette.custom.solidButtonText,
    textTransform: 'none',
    height: '56px',
    alignSelf: 'stretch',
    '&:hover': {
      backgroundColor: theme.palette.secondary.blue,
    },
    '&:disabled': {
      backgroundColor: theme.palette.secondary.gray,
      color: theme.palette.primary.white,
    },
  },
  form: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(10),
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  commentEditorWrapper: {
    position: 'relative',
  },
  commentLabel: {
    position: 'absolute',
    top: '-8px',
    left: '12px',
    zIndex: 1,
    padding: '0 4px',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  commentEditor: {
    boxSizing: 'border-box',
    minHeight: '56px',
    maxHeight: '152px',
    overflowY: 'auto',
    padding: '16px 14px',
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    outline: 'none',
    whiteSpace: 'pre-wrap',
    '&:focus': {
      borderColor: theme.palette.primary.main,
    },
    '&:empty::before': {
      content: 'attr(data-placeholder)',
      color: theme.palette.text.secondary,
    },
  },
  datePickerWrapper: {
    width: '100%',
  },
}));

export default useStyles;
